// removed by extract-text-webpack-plugin
module.exports = {"dataPoint":"DetailsQuotes__dataPoint__3yELI","value":"DetailsQuotes__value__2QQzd","quote":"DetailsQuotes__quote__3mVGf","wrapper":"DetailsQuotes__wrapper__1YMjf","boundaryHeader":"DetailsQuotes__boundaryHeader__2oGzw","column":"DetailsQuotes__column__20Eof","method":"DetailsQuotes__method__3Dt0c","price":"DetailsQuotes__price__3YwFH","applyFreeShipping":"DetailsQuotes__applyFreeShipping__3O2XJ"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsQuotes.scss
// module id = 1722
// module chunks = 4 14